import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
const m = window.m;

function LatestWpPostsWidget() {
  const state = {
    items: null,
    loading: false,
  };

  async function fetchLatest() {
    if (state.loading) return;
    state.loading = true;

    try {
      const res = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/wpfeed/latest',
      });
      state.items = (res && res.data) ? res.data : [];
    } catch (e) {
      state.items = [];
    } finally {
      state.loading = false;
      m.redraw();
    }
  }

  return {
    oninit() {
      fetchLatest();
    },
    view() {
      return renderWpFeedWidget(state.items);
    },
  };
}

function renderWpFeedWidget(items) {
  if (!items || items.length === 0) return null;

  return m('div.WpFeedWidget.item-wpfeed-latest', [
    m('h2.WpFeedWidget-title', 'お知らせ'),
    m(
      'ul.WpFeedWidget-list',
      items.map((it) =>
        m(
          'li.WpFeedWidget-item',
          m('a', { href: it.url, target: '_blank', rel: 'noopener noreferrer' }, [
            m('div.WpFeedWidget-itemTitle', it.title),
            it.excerpt ? m('div.WpFeedWidget-itemExcerpt', it.excerpt) : null,
          ])
        )
      )
    ),
  ]);
}

/**
 * トップページ（/）のみで表示するかどうかを判定する
 * フォロー中（/following）、タグページ（/t/xxx）、検索結果（/?q=xxx）、ページネーション（?page=N）では非表示
 */
function isHomePage() {
  const path = m.route.get();

  // タグページ（/t/xxx）を除外
  if (m.route.param('tag')) {
    return false;
  }

  // フォロー中ページ（/following）を除外
  if (path && path.startsWith('/following')) {
    return false;
  }

  // 検索結果（?q=xxx）を除外
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('q')) {
    return false;
  }

  // ページネーション（?page=N）を除外
  if (searchParams.has('page')) {
    return false;
  }

  // ルートパス（/）のみ許可
  if (!path || path === '/' || path === '') {
    return true;
  }

  // その他のパスは許可しない（安全のため）
  // ただし、基本的なインデックスページのバリエーションは許可
  return path.match(/^\/?(\?.*)?$/) !== null;
}

app.initializers.add('butterflycode-wordpress-feed', () => {
  extend(IndexPage.prototype, 'viewItems', function (items) {
    // トップページのみでウィジェットを表示
    if (!isHomePage()) {
      return;
    }
    // viewItemsの最後にウィジェットを追加（優先度-100で最下部に）
    items.add('wpfeed', m(LatestWpPostsWidget), -100);
  });
});
